import dayjs from 'dayjs';
import format from '../plugins/baseFormat';

export default class Order {
  constructor (initialData = {},) {
    const {
      code,
      store,
      delivery_form,
      stage,
      tracking_info,
      created_at,
    } = initialData;

    this.code = code || tracking_info.task_id;
    this.store_name = store ? store.name : '-';
    this.total_value = delivery_form.price;
    this.status = tracking_info.tracking_status;
    this.stage = stage;
    this.order_date = dayjs(created_at,);
  }

  get formatted_order_date () {
    return format.dateFromNow(this.order_date,);
  }

  get formatted_total_value () {
    if (this.total_value === null || this.total_value === undefined) {return '-';}
    return format.money(this.total_value,);
  }

  get formatted_status () {
    const aliases = {
      ASSIGNED: 'Atribuído',
      CREATED: 'Não atribuído',
      ON_THE_WAY: 'A caminho',
      CHECKED_IN: 'Chegou ao destino',
      DONE: 'Concluído',
      NOT_USED: 'Status não usado',
      ACCEPTED: 'Aceito',
      CANCELED: 'Cancelado',
      REJECTED: 'Rejeitado',
      UNACKNOWLEDGED: 'Status desconhecido',
    };

    return aliases[this.status] || 'Desconhecido';
  }

  get formatted_stage () {
    const aliases = {
      WAITING_PAYMENT: 'Aguardando pagamento',
      WAITING_COMPANY: 'Aguardando aprovação',
      CONFIRMED: 'Confirmado',
      READY: 'Pronto para entrega',
      DELIVERED: 'Entregue',
      ASSIGNED: 'Atribuído',
      CREATED: 'Não atribuído',
      ON_THE_WAY: 'A caminho',
      CHECKED_IN: 'Chegou ao destino',
      DONE: 'Concluído',
      NOT_USED: 'Status não usado',
      ACCEPTED: 'Aceito',
      CANCELED: 'Cancelado',
      REJECTED: 'Rejeitado',
      UNACKNOWLEDGED: 'Status desconhecido',
    };

    return aliases[this.stage] || 'Desconhecido';
  }
}
